import React from 'react';
import exportBackground from '../assets/export/export-background.jpg';
import shippingImage from '../assets/export/shipping.jpeg';
import spicesBackground from '../assets/spices-home/spices-home-bg.png';
import colourfulSpicesImage from '../assets/spices-home/colourfulSpices.jpg';
import labBackground from '../assets/lab-home/lab-bg.jpeg';
import labForeground from '../assets/lab-home/lab-fg.jpeg';
import productListBackground from '../assets/list-home/list-bg.jpeg';
import spicesListImage from '../assets/list-home/spices-list.jpeg';
import dpListImage from '../assets/list-home/dp-list.jpeg';
import productListImageOne from '../assets/list-home/list1.jpeg';
import productListImageTwo from '../assets/list-home/list2.jpeg';

function HomeSection({ onExploreProducts, onContactUs }) {
  return (
    <>
      <section
        className="home-hero"
        style={{ backgroundImage: `linear-gradient(rgba(255, 250, 245, 0.78), rgba(255, 250, 245, 0.78)), url(${spicesBackground})` }}
      >
        <div className="home-hero-inner home-hero-inner-reverse">
          <div className="home-hero-media">
            <img
              src={colourfulSpicesImage}
              alt="Colorful premium spices arranged in bowls"
              className="home-hero-image"
            />
          </div>

          <div className="home-hero-copy">
            <span className="home-eyebrow">Spices We Offer</span>
            <h2 className="home-hero-title">
              Fresh, aromatic spices selected for strong flavor, rich color, and dependable quality.
            </h2>
            <p className="home-hero-text">
            We are a trusted exporter and supplier of premium-quality Indian spices, serving global markets with excellence and reliability. <strong>Our product range includes whole spices, spice powders, dehydrated powders, flakes, and customized spice ingredients,</strong> all sourced from the finest regions of India and processed to meet international quality standards.
            </p>
            <p className="home-hero-text home-hero-text-secondary">
            Known for their rich aroma, authentic flavor, purity, and freshness, our spices are carefully packaged to preserve their quality. With a strong commitment to hygienic processing, timely delivery, and customer satisfaction, we provide reliable spice solutions for importers, wholesalers, food manufacturers, and distributors worldwide.
            </p>
            <button className="home-cta" onClick={onExploreProducts}>
              Explore Products
            </button>
          </div>
        </div>
      </section>

      <section
        className="home-hero"
        style={{ backgroundImage: `linear-gradient(rgba(255, 255, 255, 0.82), rgba(255, 255, 255, 0.82)), url(${productListBackground})` }}
      >
        <div className="home-products-showcase">
          <div className="home-products-copy">
            <span className="home-eyebrow">Our Products</span>
            <h2 className="home-hero-title">A quick look at our product range.</h2>
          </div>

          <div className="home-products-grid">
            <img
              src={spicesListImage}
              alt="Daughters Enterprise spices product list preview"
              className="home-products-grid-image"
            />
            <img
              src={dpListImage}
              alt="Daughters Enterprise dehydrated powder product list preview"
              className="home-products-grid-image"
            />
            <img
              src={productListImageOne}
              alt="Daughters Enterprise product list preview one"
              className="home-products-grid-image"
            />
            <img
              src={productListImageTwo}
              alt="Daughters Enterprise product list preview two"
              className="home-products-grid-image"
            />
          </div>
          <button className="home-cta" onClick={onExploreProducts}>
              Explore Products
          </button>
        </div>
      </section>

      <section
        className="home-hero"
        style={{ backgroundImage: `linear-gradient(rgba(255, 255, 255, 0.72), rgba(255, 255, 255, 0.72)), url(${exportBackground})` }}
      >
        <div className="home-hero-inner">
          <div className="home-hero-copy">
            <span className="home-eyebrow">Export Excellence</span>
            <h1 className="home-hero-title">
              We export premium spices, herbal powders, and dry fruits with trusted quality.
            </h1>
            <p className="home-hero-text">
              Daughters Enterprise supplies carefully selected products for retail and wholesale
              buyers, with dependable packing, smooth dispatch, and direct business support.
            </p>

            <div className="home-hero-stats">
              <div className="home-stat">
                <strong>100+</strong>
                <span>Products Ready</span>
              </div>
              <div className="home-stat">
                <strong>5</strong>
                <span>Core Categories</span>
              </div>
              <div className="home-stat">
                <strong>100%</strong>
                <span>Quality Focused</span>
              </div>
            </div>

            <button className="home-cta" onClick={onContactUs}>
              Contact Us
            </button>
          </div>

          <div className="home-hero-media">
            <img
              src={shippingImage}
              alt="Export shipment and packaged products"
              className="home-hero-image"
            />
          </div>
        </div>
      </section>

      <section
        className="home-hero"
        style={{ backgroundImage: `linear-gradient(rgba(248, 252, 255, 0.8), rgba(248, 252, 255, 0.8)), url(${labBackground})` }}
      >
        <div className="home-hero-inner home-hero-inner-reverse">
          <div className="home-hero-media">
            <img
              src={labForeground}
              alt="Lab quality reports and certification documents"
              className="home-hero-image"
            />
          </div>

          <div className="home-hero-copy">
            <span className="home-eyebrow">Lab Reports</span>
            <h2 className="home-hero-title">
              Lab reports, certifications, and product documents can be provided for the goods we sell.
            </h2>
            <p className="home-hero-text">
              We understand that quality verification matters for serious buyers. For selected
              products, we can provide supporting lab reports, certifications, and related product
              documents to help with buyer review, compliance discussions, and purchase confidence.
            </p>
            <p className="home-hero-text home-hero-text-secondary">
              This makes our supply process better suited for wholesalers, retailers, and export
              partners who need clearer quality assurance before placing larger orders.
            </p>
          </div>
        </div>
      </section>
    </>
  );
}

export default HomeSection;
